<template>
<div>
  <!-- Quantity Confirmation Overlay -->
  <div v-if="showQuantityConfirmOverlay" class="location-overlay">
    <div class="overlay-content">
      <h3 class="overlay-title">Confirm Location</h3>
      <p class="overlay-subtitle">
        Scan the shelf QR code to confirm location<br />
        <strong>{{ article && article.localLocation }}</strong>
      </p>
      <b-form-input
        ref="quantityConfirmInput"
        v-model="quantityConfirmScan"
        @keyup.enter="processQuantityConfirmation"
        placeholder="Scan shelf code to confirm"
        class="location-input"
        size="lg"
      ></b-form-input>
      <div class="overlay-buttons">
        <b-button @click="processQuantityConfirmation" variant="success" size="lg" class="me-2">
          Confirm &amp; Save
        </b-button>
        <b-button @click="closeQuantityConfirmOverlay" variant="secondary" size="lg">
          Cancel
        </b-button>
      </div>
    </div>
  </div>

  <!-- Location Scanner Overlay -->
  <div v-if="showLocationOverlay" class="location-overlay">
    <div class="overlay-content">
      <h3 class="overlay-title">Scan Shelf QR Code</h3>
      <p class="overlay-subtitle">Please scan the QR code on the shelf to load location</p>
      <b-form-input
        ref="locationInput"
        v-model="scannedLocation"
        @keyup.enter="processScannedLocation"
        placeholder="Scan shelf code or enter location manually"
        class="location-input"
        size="lg"
      ></b-form-input>
      <div class="overlay-buttons">
        <b-button @click="processScannedLocation" variant="success" size="lg" class="me-2">
          Process Location
        </b-button>
        <b-button @click="closeLocationOverlay" variant="secondary" size="lg">
          Cancel
        </b-button>
      </div>
    </div>
  </div>

  <div v-if="allArticles.length" class="ean-options bg-primary p-2">
    <span>There are multiple products with that same EAN code:</span>
    <ul class="list-group">
      <li @click="chooseProduct(a)" v-for="(a, i) in allArticles" :key="i" class="list-group-item list-group-item-action pointer">
        {{a.name}}
      </li>
    </ul>
  </div>
  <div class="info-page">
    <div v-if="error" class="w-100 alert alert-danger">{{error}}</div>
    <div v-if="show" class="text-center">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <div class="kartica" v-else>
      <div class="article-panel">
        <div class="article-head">
          <h5 class="article-name">{{ article.name }}</h5>
          <b-button
            v-if="articleImage"
            class="info-btn image-btn"
            variant="outline-secondary"
            @click="imageOpen = !imageOpen">
            <b-icon icon="image"></b-icon> {{ imageOpen ? 'HIDE' : 'IMAGE' }}
          </b-button>
        </div>
        <div v-if="imageOpen && articleImage" class="article-image">
          <b-img :src="articleImage" fluid alt="Product image" class="max-height-image"></b-img>
        </div>
        <div class="table-container">
          <b-table
            :items="article.productCodes.productCode"
            :fields="codeFields"
            head-variant="dark"
            sticky-header="37vh"
            responsive="sm"
            class="mb-0"
          >
          </b-table>
        </div>
      </div>
      <b-card
        :header="article.codename"
        header-tag="header">
        <b-card-text>
          <div class="qty-row">
            <span class="kolicina">{{article.localCount}}</span>
            <div class="info-actions">
            <b-button size="lg"
              :disabled=disejblujKolicinu
              @click="qtt('-', $event)"
              class="info-btn"
              href="#"
              variant="danger">
              <b-icon-arrow-down></b-icon-arrow-down>
            </b-button>

            <b-button size="lg"
              :disabled=disejblujKolicinu
              @click="qtt('+', $event)"
              class="info-btn"
              href="#"
              variant="success">
              <b-icon-arrow-up></b-icon-arrow-up>
            </b-button>
            <b-button size="lg"
              :disabled=disejblujKolicinu
              @click="saveQuantity($event)"
              class="info-btn" href="#"
              variant="success">
              <b-icon-check></b-icon-check>
            </b-button>
            </div>
          </div>
        </b-card-text>
      </b-card>

      <b-card
        class="location-card"
        :header="article.localLocation || 'No location'"
        header-tag="header">
        <div class="location-grid">
          <b-form-select size="lg" v-model="locationSelected.raf" :options="rafe"></b-form-select>
          <b-form-select size="lg" v-model="locationSelected.kolona" :options="kolone"></b-form-select>
          <b-form-select size="lg" v-model="locationSelected.red" :options="redovi"></b-form-select>
          <b-form-select size="lg" v-model="locationSelected.box" :options="boxovi"></b-form-select>
        </div>
        <div class="info-actions location-actions">
          <b-button size="lg"
            :disabled=disejblujLokaciju
            @click="openLocationScanner"
            class="info-btn" href="#"
            variant="info">
            <b-icon-upc-scan></b-icon-upc-scan>
          </b-button>
          <b-button size="lg"
            :disabled=disejblujLokaciju
            @click="saveLocation"
            class="info-btn" href="#"
            variant="success">
            <b-icon-check></b-icon-check>
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';

import fixed from '@/fixed';

export default {
  data() {
    return {
      error: '',
      show: true,
      disejblujKolicinu: true,
      disejblujLokaciju: true,
      allArticles: [],
      article: null,
      imageOpen: false,
      // Code Simplified nearly repeats Code, so PDAs drop it rather than scroll sideways.
      codeFields: [
        { key: 'abbreviation', label: 'Type' },
        { key: 'code', label: 'Code' },
        {
          key: 'codeSimplified',
          label: 'Code Simplified',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
        },
      ],
      lok: {
        sku: '',
        location: 'LOCATION',
      },
      kolicina: {
        sku: '',
        qtt: 0,
      },
      rafe: fixed.locations.rafe,
      kolone: fixed.locations.kolone,
      redovi: fixed.locations.redovi,
      boxovi: [
        { value: null, text: 'Select box (optional)' },
      ],
      locationSelected: {
        raf: '',
        kolona: '',
        red: '',
        box: '',
      },
      showLocationOverlay: false,
      scannedLocation: '',
      showQuantityConfirmOverlay: false,
      quantityConfirmScan: '',
    };
  },
  computed: {
    articleImage() {
      return this.article?.images?.image?.[0]?.url;
    },
  },
  created() {
    this.populateBoxes();
  },
  async mounted() {
    const uri = `${fixed.API_URL}/admin/scan/${this.$route.params.ean}`;
    try {
      const { data: { data } } = await axios.get(uri, { withCredentials: true });
      if (!data) { // if we don't have data we go back to scanner
        this.$toast.info('No article with that code');
        await this.$router.push('/manual');
        return;
      }

      if (data.length > 1) {
        this.allArticles = data;
      }

      this.chooseProduct(data[0]);

      const opcije = this.article.localLocation ? this.article.localLocation.split(' ') : '';
      this.disejblujKolicinu = false;
      this.disejblujLokaciju = false;
      if (opcije.length > 1) {
        const [raf, kolona, red, box] = opcije;
        // eslint-disable-next-line object-curly-newline
        this.locationSelected = { raf, kolona, red, box };
      } else {
        this.showLocationOverlay = true;
        this.$nextTick(() => {
          this.$refs.locationInput.focus();
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        this.error = 'you\'re not authorised for that action ✋🏻'; // eslint-disable-line
      } else {
        this.error = error;
      }
    }
    this.show = false;
  },
  methods: {
    chooseProduct(a) {
      this.article = a;
      this.imageOpen = false;
      if (!Object.hasOwn(this.article, 'localCount')) this.$set(this.article, 'localCount', 0);
    },
    qtt(operator, event) {
      this.blurTarget(event);
      if (operator === '-' && this.article.localCount < 1) return;

      if (operator === '+') {
        this.article.localCount += 1;
      } else {
        this.article.localCount -= 1;
      }
    },
    blurTarget(event) {
      // Handheld scanners emit keystrokes ending with Enter/Tab; if a button
      // keeps focus after a click those keys will re-trigger the click and
      // silently mutate state (e.g. bump quantity). Blur to neutralize that.
      const el = event && event.currentTarget;
      if (el && typeof el.blur === 'function') el.blur();
      else if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    },
    async saveLocation() {
      if (!this.locationSelected.raf || !this.locationSelected.kolona || !this.locationSelected.red) return; // eslint-disable-line

      const cleanBox = !this.locationSelected.box || this.locationSelected.box === ' ' || this.locationSelected.box === 'undefined' || this.locationSelected.box === 'null' ? '' : this.locationSelected.box;
      this.lok.location = `${this.locationSelected.raf} ${this.locationSelected.kolona} ${this.locationSelected.red} ${cleanBox}`;
      this.lok.sku = this.article.codename;

      const url = `${fixed.API_URL}/admin/location`;
      try {
        this.show = true;
        await axios.put(url, this.lok, { withCredentials: true });
        this.$toast.success('Saved successfully');
      } catch (error) {
        this.error = error;
      }
      this.show = false;
      this.article.localLocation = this.lok.location;
    },
    async saveQuantity(event) {
      this.blurTarget(event);
      if (!this.article || !this.article.localLocation || this.article.localLocation.trim().split(' ').length < 3) {
        this.$toast.warning('Please set a valid location before saving quantity.');
        return;
      }
      // Always start with a clean confirmation state to avoid stale scans.
      this.quantityConfirmScan = '';
      this.showQuantityConfirmOverlay = true;
      this.$nextTick(() => {
        if (this.$refs.quantityConfirmInput) this.$refs.quantityConfirmInput.focus();
      });
    },
    normalizeLocation(value) {
      return (value || '')
        .toString()
        .trim()
        .replace(/\s+/g, ' ')
        .toUpperCase();
    },
    async processQuantityConfirmation() {
      const scanned = this.normalizeLocation(this.quantityConfirmScan);
      const expected = this.normalizeLocation(this.article && this.article.localLocation);

      if (!scanned) return;

      if (scanned !== expected) {
        this.$toast.error('Scanned location does not match. Please scan the correct shelf.');
        this.quantityConfirmScan = '';
        this.$nextTick(() => {
          if (this.$refs.quantityConfirmInput) this.$refs.quantityConfirmInput.focus();
        });
        return;
      }

      this.showQuantityConfirmOverlay = false;
      this.quantityConfirmScan = '';
      await this.persistQuantity();
    },
    closeQuantityConfirmOverlay() {
      this.showQuantityConfirmOverlay = false;
      this.quantityConfirmScan = '';
    },
    async persistQuantity() {
      this.kolicina.qtt = this.article.localCount;
      this.kolicina.sku = this.article.codename;

      const url = `${fixed.API_URL}/admin/quantity`;
      this.show = true;
      try {
        await axios.put(url, this.kolicina, { withCredentials: true });
        if (this.error) this.error = '';
        this.$toast.success('Saved successfully');
      } catch (error) {
        this.error = error.response ? error.response.data : error;
      }
      this.show = false;
    },
    populateBoxes() {
      for (let i = 1; i <= 200; i += 1) {
        this.boxovi.push({ value: `Box${i}`, text: `Box ${i}` });
      }
    },
    processScannedLocation() {
      const location = this.scannedLocation.trim();
      if (!location) return;

      const parts = location.split(' ');
      if (parts.length < 3) {
        this.$toast.warning('Invalid location format. Please scan again.');
        return;
      }

      const [raf, kolona, red, box] = parts;
      this.locationSelected = {
        raf,
        kolona,
        red,
        box,
      };
      this.showLocationOverlay = false;
      this.saveLocation();
    },
    closeLocationOverlay() {
      this.showLocationOverlay = false;
      // this.$router.push('/manual');
    },
    openLocationScanner() {
      this.scannedLocation = '';
      this.showLocationOverlay = true;
      this.$nextTick(() => {
        this.$refs.locationInput.focus();
      });
    },
  },
};
</script>

<style>
.info-page {
  max-width: 980px;
  margin: 0 auto;
  padding-top: 1rem;
}

.kartica .card-header {
  font-size: 1.3rem;
}

.kartica {
  color: #222222
}
.kolicina {
  margin-left: 0.5rem;
  font-size: 2.6rem;
  font-weight: 750;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}
.dugmad {
  margin: 9px 0 0 6px;
  min-width: 56px;
  border-radius: var(--radius) !important;
}
.dugme {
  width: 85%;
  float: right;
}
.ean-options {
  margin-bottom: 1rem;
  border-radius: var(--radius-sm);
}

.navi-dugme {
  position: fixed;
  bottom: 10px;
  width: 100vw;
}

.article-panel {
  overflow: hidden;
  margin: 1rem 0;
  background-color: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.article-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.75rem;
}

.article-name {
  margin: 0;
  color: var(--text);
  overflow-wrap: anywhere;
}

.article-image {
  padding: 0.75rem;
  text-align: center;
  background-color: #fff;
}

.qty-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.info-actions {
  display: flex;
  gap: 0.5rem;
}

/* The buttons give way so a long stock count stays on the row */
.qty-row .info-actions {
  flex: 1 1 auto;
  justify-content: flex-end;
  min-width: 0;
}

.qty-row .info-btn {
  flex: 0 1 76px;
  min-width: 0;
}

/* Sized for gloved thumbs on the PDAs */
.info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 76px;
  min-height: 60px;
  font-size: 1.5rem;
  border-radius: var(--radius) !important;
}

.info-btn .b-icon.bi {
  font-size: 1.75rem;
}

.image-btn .b-icon.bi {
  font-size: 1.25rem;
}

.image-btn {
  flex: 0 0 auto;
  gap: 0.4rem;
  min-width: 0;
  min-height: 52px;
  font-size: 1rem;
}

.location-card {
  margin-top: 15px;
}

.location-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.location-grid .custom-select {
  height: 52px;
}

.location-actions {
  margin-top: 0.75rem;
}

.location-actions .info-btn {
  flex: 1;
}

.max-height-image {
  max-height: 30vh;
  width: auto;
  object-fit: contain;
}

.table-container {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.table-container >>> .table.b-table {
  flex: 1;
}

.location-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.overlay-content {
  background-color: var(--surface-2);
  border: 1px solid var(--border-strong);
  padding: 2rem;
  border-radius: var(--radius-lg);
  text-align: center;
  width: 90%;
  max-width: 500px;
}

.overlay-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.overlay-subtitle {
  font-size: 1rem;
  margin-bottom: 2rem;
}

.location-input {
  background-color: var(--border-strong);
  color: white;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 0.75rem;
  width: 100%;
  margin-bottom: 1rem;
}

.overlay-buttons {
  display: flex;
  justify-content: space-between;
}

/* PDAs: everything on one screen, three code rows with the fourth peeking in to
   show the table scrolls. */
@media (max-width: 767.98px) {
  .info-page {
    padding-top: 0;
  }

  .info-page .article-panel {
    margin: 0 0 0.5rem;
  }

  .info-page .article-head {
    padding: 0.4rem 0.6rem;
  }

  .info-page .article-name {
    font-size: 0.95rem;
  }

  .info-page .image-btn {
    min-height: 44px;
    padding: 0 0.6rem;
    font-size: 0.9rem;
  }

  .info-page .table-container .b-table-sticky-header {
    max-height: 150px !important;
  }

  .info-page .table-container th,
  .info-page .table-container td {
    padding: 0.35rem 0.6rem;
  }

  .info-page .card-header {
    padding: 0.35rem 0.6rem;
    font-size: 1rem;
  }

  .info-page .card-body {
    padding: 0.5rem 0.6rem;
  }

  .info-page .card-text {
    margin: 0;
  }

  .info-page .location-card {
    margin-top: 0.5rem;
  }

  .info-page .kolicina {
    margin-left: 0;
    font-size: 2rem;
  }

  .info-page .info-btn {
    min-height: 52px;
  }

  .info-page .location-grid .custom-select {
    height: 44px;
  }

  .info-page .location-actions {
    margin-top: 0.5rem;
  }
}
</style>
